import { LogLevel } from "@microsoft/signalr";
import EndpointsBase from "../EndpointsBase";

class OperatorEndpoints extends EndpointsBase {
  login(operatorID: number, companyID: number, workstationID: number = -1, view: number = 0) {
    return this._sendRequest({
      method: `operator/login/${operatorID}/${companyID}/${view}?workstationID=${workstationID}`,
      data: {},
      run: this.server.postData,
    });
  }
  authorizedLogin(key: string) {
    return this._sendRequest({
      method: `operator/authorizedlogin/`,
      data: { key },
      run: this.server.getData,
    });
  }
  canVerifyRXBag(
    operatorIDString: string,
    sortBoxID: number,
    orderNumber: number,
    isScanIdValidationRxRequired: boolean = false
  ) {
    return this._sendRequest({
      method: "operator/canverifyrxbag",
      headers: this._getAuthHeader(),
      data: { operatorIDString, sortBoxID, orderNumber, isScanIdValidationRxRequired },
      run: this.server.getData,
    });
  }
  getActivityStatuses(operatorId: number) {
    return this._sendRequest({
      method: "operator/getActivityStatuses",
      headers: this._getAuthHeader(),
      data: { operatorId },
      run: this.server.getData,
    });
  }
  getOperatorStatuses(operatorId: number) {
    return this._sendRequest({
      method: "operator/status",
      headers: this._getAuthHeader(),
      data: { operatorId },
      run: this.server.getData,
    });
  }
  clearPendingInstructions() {
    return this._sendRequest({
      method: "operator/clearPendingInstructions",
      headers: this._getAuthHeader(),
      data: {},
      run: this.server.postData,
    });
  }
  getWorkstationInstruction(workstationID: number) {
    return this._sendRequest({
      method: "operator/instruction",
      headers: this._getAuthHeader(),
      data: { workstationID },
      run: this.server.getData,
    });
  }
  canPartialDeliver(scannedID: string) {
    return this._sendRequest({
      method: "operator/canpartialdeliver",
      headers: this._getAuthHeader(),
      data: { scannedID },
      run: this.server.getData,
    });
  }
}

export default new OperatorEndpoints();
